import SummaryStep from '../components/summary-step.component';

export default {
  title: 'Submit',
  nonFunctional: true,
  description: 'Submit',
  component: SummaryStep,
};
